<template>
  <router-view></router-view>
</template>

<style lang="scss">
// 3rd party plugins css
@import "~bootstrap-vue/dist/bootstrap-vue.css";
@import "~perfect-scrollbar/css/perfect-scrollbar.css";
@import "~socicon/css/socicon.css";
@import "~animate.css";
@import "~@fortawesome/fontawesome-free/css/all.css";
@import "~line-awesome/dist/line-awesome/css/line-awesome.css";
@import "assets/plugins/flaticon/flaticon.css";
@import "assets/plugins/flaticon2/flaticon.css";
@import "assets/plugins/keenthemes-icons/font/ki.css";

// Main demo style scss
@import "assets/sass/style.vue";
@import "assets/sass/medhop-enterprise";
@import "assets/sass/medhop-dashboard";
@import "assets/sass/medhop-compact-pages";
@import "assets/sass/medhop-modern-foundation";
@import "assets/sass/medhop-crm";
@import "assets/sass/medhop-date-range-filter";
@import "assets/sass/medhop-search-filter";
@import "assets/sass/medhop-mobile";
@import "assets/sass/medhop-ui-fixes";
@import "assets/sass/components/button-icon-contrast";
@import "assets/sass/components/search-field-layout";
@import "assets/sass/vertical-skins";

// Check documentation for RTL css
// Update HTML with RTL attribute at public/index.html
/*@import "assets/css/style.vue.rtl";*/
</style>

<script>

import { getUser } from '@/core/services/jwt.service.js'
import { UPDATE_PERSONAL_INFO } from '@/core/services/store/profile.module'
import { OVERRIDE_LAYOUT_CONFIG } from "@/core/services/store/config.module";
import ProductConfigurationService from '@/core/services/product-configuration.service.js'
import VerticalSkinService from '@/core/services/vertical-skin.service.js'

export default {
  name: "MetronicVue",
  mounted() {
    /**
     * this is to override the layout config using saved data from localStorage
     * remove this to use config only from static json (@/core/config/layout.config.json)
     */
    this.$store.dispatch(OVERRIDE_LAYOUT_CONFIG);
    this.$store.dispatch(UPDATE_PERSONAL_INFO, getUser())
    this.handleProductConfiguration({ detail: ProductConfigurationService.current() })
    window.addEventListener('medhop:product-configuration', this.handleProductConfiguration)
  },
  beforeDestroy() {
    window.removeEventListener('medhop:product-configuration', this.handleProductConfiguration)
  },
  methods: {
    handleProductConfiguration(event) {
      VerticalSkinService.apply(event && event.detail)
    },
  }
};
</script>
